import Solped from '@/interfaces/Solped';

function formatSolpedId(id: Solped['id']): string {
   if (!id) return '';
   return `#SP-${id.toString().padStart(5, '0')}`;
}

export default formatSolpedId;
